import React, { useState } from 'react';
import '../../entrydoor.css';

const DecorativeTips = ({ value, onChange, label = 'Decorative Tips:' }) => {
    const [selectedDecorativeTips, setSelectedDecorativeTips] = useState(value || "");

    const handleDecorativeTipsChange = (e) => {
        setSelectedDecorativeTips(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} htmlFor="DecorativeTips">{label}</label>
            <select style={{ display: "none" }}
                id="DecorativeTips"
                value={selectedDecorativeTips}
                onChange={handleDecorativeTipsChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="Yes">{selectedDecorativeTips === "Yes" ? "Yes ✔" : "Yes"}</option>
                <option value="No">{selectedDecorativeTips === "No" ? "No ✔" : "No"}</option>
            </select>
        </div>
    );
};

export default DecorativeTips;
